interface AuthFormAlertsProps {
  readonly authError: string | null;
  readonly showPasswordResetHint: boolean;
}

export function AuthFormAlerts({
  authError,
  showPasswordResetHint,
}: AuthFormAlertsProps) {
  return (
    <>
      {authError && (
        <div
          role="alert"
          className="rounded-lg border border-red-200 bg-red-50 p-3 text-sm text-red-800"
        >
          {authError}
        </div>
      )}

      {showPasswordResetHint && (
        <div
          role="status"
          className="rounded-lg border border-primary-200 bg-primary-50 p-3 text-sm leading-snug text-gray-800"
        >
          Check your inbox for a password reset link. If you don’t see it, look in spam.
        </div>
      )}
    </>
  );
}
